// Routes this page does NOT serve → the page that does (DR-0045 D3/D4): the
// hub, at play.actuniverse.com on the site (ACT HQ DR-0017) and "/" in dev.
// Import-light on purpose: main.ts uses it on the pre-boot redirect path, which
// must stay feather-light (no engine, no core graph; the platform's pages
// module is a few constants).
import { HUB_PAGE_BASE } from "@act/client-core/pages";

export const FOREIGN_ROUTES: Readonly<Record<string, string>> = Object.fromEntries(
  ["hub", "equip", "photo"].map((route) => [route, HUB_PAGE_BASE]),
);
